import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";

const API_NAME = "catalogueItemUserBid";

export const catalogueItemUserBidService = {
    getActive,
    post,
    typeBid
};

function getActive(catalogueItemId: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getActive/?catalogueItemId=${catalogueItemId}`, requestOptions).then(handleResponse);
}


function post(catalogueItemId: number, bid: string, catalogueUserId?: number) {
    const requestOptions = { method: 'POST', headers: getHeader(), body: getBody({ catalogueItemId: catalogueItemId, bid: bid, catalogueUserId: catalogueUserId }) };
    return fetch(`${API_URL}/${API_NAME}/create`, requestOptions).then(handleResponse);
}

function typeBid(catalogueItemId: number, bid: string, catalogueUserId?: number) {
    const requestOptions = { method: 'POST', headers: getHeader(), body: getBody({ catalogueItemId: catalogueItemId, bid: bid, catalogueUserId: catalogueUserId }) };
    return fetch(`${API_URL}/${API_NAME}/typeBid`, requestOptions).then(handleResponse);
}